import { useState } from 'react';import { useSearchParams, useNavigate } from 'react-router-dom';
import supabase from '../supabase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSiteLang as useLang } from '../siteLang';
import '../design-system.css';

const t = {
    fr: {
        title: 'Se désabonner', subtitle: 'Confirme pour arrêter de recevoir nos courriels.',
        confirm: 'Confirmer le désabonnement', confirming: 'Traitement...',
        doneTitle: 'Désabonné', doneBody: 'Tu ne recevras plus de courriels de notre part. Tu peux te réinscrire en tout temps.',
        errInvalid: 'Lien invalide — email manquant.', errFail: 'Une erreur est survenue.',
        backHome: '← winston.ie',
    },
    en: {
        title: 'Unsubscribe', subtitle: 'Confirm to stop receiving our emails.',
        confirm: 'Confirm unsubscribe', confirming: 'Processing...',
        doneTitle: 'Unsubscribed', doneBody: 'You will no longer receive emails from us. You can resubscribe anytime.',
        errInvalid: 'Invalid link — missing email.', errFail: 'Something went wrong.',
        backHome: '← winston.ie',
    },
    vi: {
        title: 'Hủy đăng ký', subtitle: 'Xác nhận để ngừng nhận email của chúng tôi.',
        confirm: 'Xác nhận hủy đăng ký', confirming: 'Đang xử lý...',
        doneTitle: 'Đã hủy đăng ký', doneBody: 'Bạn sẽ không còn nhận email từ chúng tôi. Bạn có thể đăng ký lại bất cứ lúc nào.',
        errInvalid: 'Liên kết không hợp lệ — thiếu email.', errFail: 'Đã xảy ra lỗi.',
        backHome: '← winston.ie',
    },
};

function Unsubscribe() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { lang } = useLang();
    const c = t[lang] || t.fr;

    const email = searchParams.get('email');
    const [status, setStatus] = useState('idle'); // idle | loading | done | error

    const handleConfirm = async () => {
        if (!email) { setStatus('error'); return; }
        setStatus('loading');

        const { error } = await supabase
            .from('newsletter_subscribers')
            .update({ unsubscribed: true })
            .eq('email', email);

        if (error) { setStatus('error'); return; }
        setStatus('done');
    };

    if (!email) {
        return (
            <div className="w-page">
                <Navbar variant="light" />
                <div className="w-body" style={{ maxWidth: '440px', textAlign: 'center', paddingTop: '80px' }}>
                    <p className="w-subtitle">{c.errInvalid}</p>
                </div>
                <Footer variant="light" />
            </div>
        );
    }

    return (
        <div className="w-page">
            <Navbar variant="light" />
            <div className="w-body" style={{ maxWidth: '440px', textAlign: 'center', paddingTop: '80px' }}>
                <p className="w-eyebrow" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>{c.backHome}</p>

                {status === 'done' ? (
                    <>
                        <h1 className="w-title">{c.doneTitle}</h1>
                        <p className="w-subtitle">{c.doneBody}</p>
                    </>
                ) : (
                    <>
                        <h1 className="w-title" style={{ marginBottom: '4px' }}>{c.title}</h1>
                        <p className="w-subtitle" style={{ marginBottom: '28px' }}>{c.subtitle}</p>
                        <p style={{ fontSize: '12.5px', color: 'var(--w-muted)', marginBottom: '24px' }}>{email}</p>

                        {status === 'error' && (
                            <p style={{ color: '#a3382f', fontSize: '12.5px', marginBottom: '20px' }}>{c.errFail}</p>
                        )}

                        <button className="w-btn-primary" onClick={handleConfirm} disabled={status === 'loading'}>
                            {status === 'loading' ? c.confirming : c.confirm}
                        </button>
                    </>
                )}
            </div>
            <Footer variant="light" />
        </div>
    );
}

export default Unsubscribe;